export function formatDate(
  date: Date | string | number | undefined,
  opts: Intl.DateTimeFormatOptions = {}
) {
  if (!date) return "";

  try {
    return new Intl.DateTimeFormat("en-US", {
      month: opts.month ?? "long",
      day: opts.day ?? "numeric",
      year: opts.year ?? "numeric",
      ...opts,
    }).format(new Date(date));
  } catch (_err) {
    return "";
  }
}

export function formatGateAssignmentType(type: string) {
  switch (type) {
    case "known":
      return "Known";
    case "historic":
      return "Historic";
    case "failed":
      return "Failed";
    case "preferred":
      return "Preferred";
    case "random":
      return "Logic";
    default:
      return "Unknown";
  }
}

export function formatBaggageAssignmentType(type: string | null | undefined) {
  if (!type) return null;
  switch (type) {
    case "known":
      return "OAG";
    case "preferred":
      return "Preferred";
    case "random":
      return "Logic";
    case "failed":
      return "Failed";
    default:
      return "Unknown";
  }
}

export function formatLocationType(type: string): string {
  switch (type) {
    case "gate":
      return "Gate";
    case "ticketing":
      return "Ticketing";
    case "checkpoint":
      return "Checkpoint";
    case "security_lane":
      return "Security Lane";
    case "restroom":
      return "Restroom";
    case "customs":
      return "Customs";
    case "intl_baggage":
      return "International Baggage";
    case "baggage_carousel":
      return "Baggage Carousel";
    case "door":
      return "Door";
    case "terminal":
      return "Terminal";
    case "other":
      return "Other";
    default:
      return type;
  }
}
